import { render, staticRenderFns } from "./TailwindSelect.vue?vue&type=template&id=5012dad5&"
import script from "./TailwindSelect.vue?vue&type=script&lang=ts&"
export * from "./TailwindSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports